<template>
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"
          ><i class="fas fa-bars"></i
        ></a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <li class="nav-item d-lg-block d-none">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>
      <li class="nav-item dropdown">
        <a data-bs-toggle="dropdown" href="#" class="nav-link">
          <img
            src="../../public/img/avatar.png"
            class="rounded-circle"
            style="width: 20px"
            alt=""
          />
        </a>
        <div class="dropdown-menu dropdown-menu-end">
          <span class="dropdown-item">{{
            user?.employee?.fullname ?? user?.username
          }}({{ user?.role }})</span>

          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item" @click.prevent="doLogout">Logout</a>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import { useRouter } from "vue-router";
import authRepository from "@/repositories/authRepository";
import { onMounted, ref } from "vue";
import axios from "axios";

export default {
  setup() {
    const router = useRouter();

    const user = ref(null);

    onMounted(() => {
      const localUser = localStorage.getItem("user");
      user.value = localUser ? JSON.parse(localUser) : null;
    });

    const loading = ref(false);
    const doLogout = async () => {
      if (confirm("Are you sure you want to logout?")) {
        loading.value = true;
        try {
          await authRepository.logout();
          console.log("Logout API done");
          // localStorage.removeItem("token");
          // localStorage.removeItem("user");
          // delete axios.defaults.headers.common["Authorization"];
          // router.push({ name: "auth" });
        } catch (error) {
          console.error("Gagal logout dari server:", error);
          // Tambahkan notifikasi atau alert kalau mau
        } finally {
          delete axios.defaults.headers.common["Authorization"];
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          console.log("LocalStorage cleared");

          loading.value = false;
          
          // Tunggu 1 tick agar localStorage update terbaca
          setTimeout(() => {
            router.push({ name: "auth" });
          }, 50); // 50ms delay cukup
        }

        
      }
    };

    return {
      doLogout,
      user,
    };
  },
};
</script>

<style></style>
